import Vue from 'vue';
import ServiceUtils from '@/common/utils/ServiceUtils'

Vue.directive('convert-fullwidth-to-halfwidth', function (el, binding, vnode) {
        const handler = function (e) {
            e.target.value = ServiceUtils.convertFullwidthToHalfwidthReturn(e.target.value);
            if(e.target.value === null || e.target.value === undefined ||  e.target.value ===''){
                return;
            }
            vnode.elm.dispatchEvent(new CustomEvent('input'));
        };
        el.addEventListener('blur', handler)
    }
);
